import { Component, ChangeDetectionStrategy, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterLink } from '@angular/router';
import { RxFor } from '@rx-angular/template/for';
import { RxIf } from '@rx-angular/template/if'
import { ButtonComponent } from '../button/button.component';
import { rxState } from '@rx-angular/state';
import { Observable, tap } from 'rxjs';

@Component({
  selector: 'lib-mobile-menu',
  standalone: true,
  imports: [CommonModule, RxFor, RxIf, RouterLink, ButtonComponent],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileMenuComponent {

  private state = rxState<{
    routes: Route[]
  }>();
  
  readonly routes$: Observable<Route[]> = this.state.select('routes');

  @Input()
  set routes(routes$: Observable<Route[]>) {
    this.state.connect('routes', routes$);
  }

}
